import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { MasterDataType } from "@type/HRM/master-data";

const apiEndPoint = `${process.env.REACT_APP_ROLE_MANAGEMENT_SERVICE_URL}${process.env.REACT_APP_ROLE_MANAGEMENT_PORT}/${process.env.REACT_APP_ROLE_MANAGEMENT_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.GET_ORGANIZATION_DATA}`;

export const getPermissionsData = (() => {
  return async (): Promise<{ data: MasterDataType[] | unknown }> => {
    return api.get(`${apiEndPoint}/permissions`).then((response) => {
      return { data: response.data.permissions };
    });
  };
})();

export const getGroupsData = (() => {
  return async (): Promise<{ data: MasterDataType[] | unknown }> => {
    return api.get(`${apiEndPoint}/groups`).then((response) => {
      return { data: response.data.groups };
    });
  };
})();
